import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../store';
import { Company, CompanyIndustryData, CompanyPostCode, CreateCompany, UpdateCompany } from '../../types/company';
import { apiSlice } from './apiSlice';

export const regionApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRegions: builder.query<[], void>({
            query: () => '/regions',
            keepUnusedDataFor: 60,
        })
    })
})

export const { useGetRegionsQuery } = regionApiSlice